<template>
    <div class="d-flex flex-column">
        <div class="d-flex flex-column form-container vehicle-information">
            <b-form-group>
                <label class="form-label more-info-section-header">Vehicle Loan Information (if you have it)</label>         
                <div class="more-info-section">
                    <b-form-group v-if="collateralTypes.length > 1" class="form-label" label="What type of vehicle is it?">
                        <b-button-group vertical class="width-full" :id="$id('vehicleinfo-type')">                        
                            <b-button variant="outline-primary" :pressed="option.coreId === vehicleType" @click="selectVehicleType(option)" v-for="option in collateralTypes" :key="option.value">{{ option.name }}</b-button>                                                                    
                        </b-button-group>                    
                    </b-form-group>
                    <b-form-group class="form-label" label="Make">
                        <b-form-input type="text" v-model="make" :id="$id('vehicleinfo-make')"/>
                    </b-form-group>
                    <b-form-group class="form-label" label="Model">
                        <b-form-input class="form-control" type="text" v-model="model" :id="$id('vehicleinfo-model')"/>
                    </b-form-group>
                    <b-form-group class="form-label" label="Mileage">
                        <vue-numeric class="form-control" separator="," v-model="mileage" :id="$id('vehicleinfo-mileage')"></vue-numeric>
                    </b-form-group>
                    <b-form-group class="form-label" label="Year">
                        <b-form-input class="form-control" type="tel" v-model="year" v-mask="'####'" :id="$id('vehicleinfo-year')"/>
                    </b-form-group>
                    <b-form-group class="form-label" label="VIN">
                        <b-form-input class="form-control" type="text" v-model="vin" :id="$id('vehicleinfo-vin')"/>
                    </b-form-group>
                    <b-form-group class="form-label" label="Name of Seller">
                        <b-form-input class="form-control" type="text" v-model="seller" :id="$id('vehicleinfo-seller')"/>
                    </b-form-group>
                </div>
            </b-form-group>
        </div>
    </div>
</template>

<script>
import { mask } from "vue-the-mask";
import { mapState, mapMutations } from "vuex";
export default {
    name: "AutoLoanQuestions",
    props: [ 'collateral-types' ],
    components: {
    },
    directives: {
        mask
    },
    created() {
        if(this.collateralTypes.length == 1) {
            this.selectVehicleType(this.collateralTypes[0]);
        }
    },
    data: function() {
        return { };
    },
    computed: {
        ...mapState([
            'vehicleCollateral',
        ]),
        vehicleType: {
            get() {
                return this.vehicleCollateral.vehicleType;
            },
            set(value) {
                this.updateVehicleType({ vehicleType: value });
            }
        },
        make: {
            get() {
                return this.vehicleCollateral.make;
            },
            set(value) {
                this.updateVehicleMake({ make: value });
            }
        },
        model: {
            get() {
                return this.vehicleCollateral.model;
            },
            set(value) {
                this.updateVehicleModel({ model: value });
            }
        },
        year: {
            get() {
                return this.vehicleCollateral.year;
            },
            set(value) {
                this.updateVehicleYear({ year: value });
            }
        },
        mileage: {
            get() {
                return this.vehicleCollateral.mileage;
            },
            set(value) {
                this.updateVehicleMileage({ mileage: value });
            }
        },
        vin: {
            get() {
                return this.vehicleCollateral.vin;
            },
            set(value) {
                this.updateVehicleVin({ vin: value });
            }
        },
        seller: {
            get() {
                return this.vehicleCollateral.seller;
            },
            set(value) {
                this.updateVehicleSeller({ seller: value });
            }
        },
    },
    methods: {
        ...mapMutations([
            "updateVehicleType",
            "updateVehicleMake",
            "updateVehicleModel",
            "updateVehicleYear",
            "updateVehicleMileage",
            "updateVehicleVin",
            "updateVehicleSeller",
        ]),
        selectVehicleType: function(opt) {
            this.vehicleType = opt.coreId;
        },
        reset() {   
            this.vehicleType = '';
            this.make = '';
            this.model = '';
            this.year = '';
            this.mileage = '';
            this.vin = '';
            this.seller = '';
        },
    },
}
</script>
